// Smooth scroll to anchor

export function scrollAnchor() {
  let anchorlinks = document.querySelectorAll(
    'a[href^="#"]:not(.section-nav-link)',
  );

  for (let item of anchorlinks) {
    item.addEventListener("click", (e) => {
      let hashval = item.getAttribute("href");
      if (hashval === "#") return;

      let target = document.querySelector(hashval);
      if (!target) return;

      const header = document.querySelector("header");
      const offset = header ? header.offsetHeight : 0;
      const top =
        target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      history.pushState(null, null, hashval);
      e.preventDefault();
    });
  }
}
